import store from '@/state/store'
import { redirectLiveview2 } from '@/helpers/navigation-guards'
import { Helper } from '@/mixin/helper'

const hasAccess = store.getters['identity/hasAccess']
const hasAccessAll = store.getters['identity/hasAccessAll']
const isNewModule = store.getters['identity/isNewModule']
const getFeatureFlagData = store.getters['identity/getFeatureFlagData']

const isFeatureFlagEnabled = (featureFlag) => {
  const value = getFeatureFlagData(featureFlag)?.value
  return value === true || value === 'true'
}

// NOTE: This is not being deleted for archieves
export const allMenu = [
  {
    id: 1,
    label: 'menuitems.menu.text',
    isTitle: true,
    isHasAccess: () => {
      return true
    },
  },
  {
    id: 2,
    label: 'menuitems.dashboards.text',
    link: '/dashboard/',
    icon: 'icon-outline_browser',
    isHasAccess: () => {
      return hasAccess([
        'a1a-dasbor-statuskendaraan:read',
        'a1e-dasbor-skorpengemudi:read',
        'a1d-dasbor-bahanbakar:read',
        'a1c-dasbor-durasi&totalmengemudi:read',
        'a1b-dasbor-jarak&totalmengemudi:read',
        'a1f-dasbor-kendaraangeolokasi:read',
      ])
    },
    module_alias: ['a1-dasbor', 'a6-dasbor-fuel'],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 3,
    label: 'menuitems.transaction.text',
    isTitle: true,
    isHasAccess: () => {
      return true
    },
  },
  {
    id: 13,
    label: 'menuitems.controlTower.text',
    icon: 'icon-outline_activity',
    link: '/controltower/',
    module_alias: 'control_tower',
    isHasAccess: () => {
      return hasAccess('control_tower:read')
    },
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 25,
    label: 'menuitems.deliveryRequest.text',
    icon: 'icon-outline_list',
    link: '/delivery-request/',
    isHasAccess: () => {
      return hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
    },
  },
  {
    id: 7,
    label: 'menuitems.delivery.text',
    icon: 'icon-outline_cube',
    link: '/delivery/',
    isHasAccess: () => {
      return hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
    },
    module_alias: 'tms-base-module',
  },
  {
    id: 16,
    label: 'menuitems.fleetTask.text',
    icon: 'icon-outline_calculate',
    link: '/fleet-task/',
    isHasAccess: () => {
      return (
        hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']) ||
        hasAccessAll([
          'fleet-task-instant:read',
          'fleet-task-instant:create',
          'fleet-task-instant:update',
          'fleet-task-instant:delete',
        ])
      )
    },
  },
  {
    id: 26,
    label: 'menuitems.fleetAvailability.text',
    icon: 'icon-outline_calendar',
    link: '/fleet-availability/',
    isHasAccess: () => {
      return hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
    },
  },
  {
    id: 19,
    label: 'menuitems.costManagement.text',
    icon: 'icon-outline_rupiah',
    link: '/cost-management/',
    isHasAccess: () => {
      return hasAccessAll([
        'financial-record:create',
        'financial-record:read',
        'financial-record:update',
        'financial-record:delete',
      ])
    },
  },
  {
    id: 11,
    label: 'menuitems.trackVideo.title',
    icon: 'icon-outline_video',
    link: '/trackvideo/',
    isHasAccess: () => {
      return hasAccessAll(['b3a-default-pelacakanvideo:read', 'vehicle_video_trackers:read'])
    },
    module_alias: 'b3-pelacakanvideo',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 12,
    label: 'menuitems.route.title',
    icon: 'icon-outline_pin-history',
    link: '/route/',
    isHasAccess: () => {
      return hasAccess([
        'd7a-default-md-route:read',
        'd7a-default-md-route:update',
        'd7a-default-md-route:create',
      ])
    },
    module_alias: 'd7-md-route',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 10,
    label: 'menuitems.penilaianPengemudi.text',
    icon: 'icon-outline_bar-chart-2',
    link: '/driverscore/',
    isHasAccess: () => {
      return hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])
    },
    module_alias: 'b4-penilaianpengemudi',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 8,
    label: 'menuitems.notifikasi.text',
    link: '/notification/',
    icon: 'icon-outline_bell',
    isHasAccess: () => {
      return hasAccess([
        'e1b-web-umum:read',
        'e1c-web-dms:read',
        'e1a-web-perilakupengemudi:read',
        'e1j-log-notification:read',
      ])
    },
    module_alias: ['e1-notifweb', 'e2-popup-notifikasi', 'e3-email-notifikasi'],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 20,
    label: 'menuitems.lisensi.text',
    icon: 'icon-outline_license-general',
    link: '/license/',
    module_alias: 'b5-lisensi',
    isHasAccess: () => {
      return hasAccess(['user_docs:read', 'vehicle_docs:read'])
    },
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 24,
    label: 'menuitems.laporan.text',
    icon: 'icon-outline_book',
    link: '/report/',
    isHasAccess: () => {
      return hasAccess([
        'a2a-report-geolokasi:read',
        'a2b-report-ringkasangeolokasi:read',
        'report_management_driver:read',
        'a2d-report-ringkasanharianpengemudi:read',
        'report_summary_day_vehicle:read',
        'report_stopped:read',
        'report_detail_vehicle_trip:read',
        'report_vehicle_trip:read',
        'report_management_vehicle:read',
        'report_alert:read',
        'report_driver_behaviour:read',
        'a3e-report-ringkasanpelanggaranpengemudi:read',
        'report_fuel:read',
        'report_door:read',
        'report_time_window:read',
        'raw_sensor_infos:read',
        'a4e-detailjamkerja:read',
        'a4f-detailjamkerjadanpto:read',
        'a4g-detailpto:read',
        'a3f-report-ringkasanperingatan:read',
      ])
    },
    module_alias: [
      'a2-report-pelacakan1',
      'a3-report-pelacakan2',
      'a4-report-sensor',
      'a5-penjadwalan-report',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 23,
    label: 'menuitems.service.text',
    icon: 'icon-outline_truck-maintenance',
    link: '/maintenance/',
    isHasAccess: () => {
      return hasAccess(['maintenance:read', 'maintenance-group:read', 'service_order:read'])
    },
    module_alias: 'm1-mtc-pemeliharaan',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 18,
    label: 'menuitems.masterData.text',
    icon: 'icon-outline_layers',
    link: '/master/',
    isHasAccess: () => {
      return hasAccess([
        'd1a-default-mdkendaraan:read',
        'd2a-default-mdpelacak:read',
        'd3a-default-mdalamat:read',
        'd4a-default-mdpengguna:read',
        'd5a-default-mdkaryawan:read',
        'd7a-default-md-route:read',
        'tms:read',
        'z1o-ibeacon-md:read',
      ])
    },
    module_alias: [
      'd1-md-kendaraan',
      'd2-md-pelacak',
      'd3-md-alamat',
      'd4-md-pengguna',
      'd5-md-karyawan',
      'd6-md-pelanggan',
      'd7-md-route',
      'tms-base-module',
      'z1-sensor',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 17,
    label: 'menuitems.trackingTemp.text',
    icon: 'icon-outline_truck-idle',
    link: '/trackingtemp/',
    isHasAccess: () => {
      return hasAccess(['temporary_live_views:read'])
    },
    module_alias: 'b2-pelacakansementara',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 9,
    label: 'menuitems.generalSetting.text',
    isTitle: true,
    isHasAccess: () => {
      return hasAccess([
        'c1a-default-setpengguna:read',
        'c2a-default-setkaryawan:read',
        'c3a-default-setkendaraan:read',
        'c4a-default-setumum:read',
        'c5a-default-setgrupkendaraan:read',
        'vehicle_odometer:read',
        'c7a-default-setpengembang:read',
        'c8a-default-set-profil-perusahaan:read',
        'help_login:read',
        'contact:read',
      ])
    },
    module_alias: [
      'c1-set-pengguna',
      'c2-set-karyawan',
      'c3-set-kendaraan',
      'c4-set-umum',
      'c5-set-grupkendaraan',
      'c6-set-odometer',
      'c7-set-pengembang',
      'c8-set-profilperusahaan',
      'c9-set-device-timeout',
      'c10-set-pemeliharaan',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 22,
    label: 'menuitems.setting.text',
    link: '/setting/',
    icon: 'icon-outline_settings',
    module_alias: [
      'c1-set-pengguna',
      'c2-set-karyawan',
      'c3-set-kendaraan',
      'c4-set-umum',
      'c5-set-grupkendaraan',
      'c6-set-odometer',
      'c7-set-pengembang',
      'c8-set-profilperusahaan',
      'c9-set-device-timeout',
      'c10-set-pemeliharaan',
    ],
    isHasAccess: () => {
      return hasAccess([
        'c1a-default-setpengguna:read',
        'c2a-default-setkaryawan:read',
        'c3a-default-setkendaraan:read',
        'c4a-default-setumum:read',
        'c5a-default-setgrupkendaraan:read',
        'vehicle_odometer:read',
        'c7a-default-setpengembang:read',
        'c8a-default-set-profil-perusahaan:read',
      ])
    },
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 33,
    label: 'menuitems.marketplace.text',
    link: '/marketplace/',
    icon: 'icon-outline_marketplace',
    isHasAccess: () => {
      return hasAccessAll(['marketplace:read'])
    },
    module_alias: ['y3-marketplace'],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 5,
    label: 'menuitems.help.text',
    link: '/help/',
    icon: 'icon-outline_question-mark-circle',
    isHasAccess: () => {
      return hasAccess([
        'help_login:read',
        'help_dasbor:read',
        'help_default:read',
        'help_notifikasi:read',
        'help_pengaturan:read',
        'help_masterdata:read',
        'help_pelacakanvideo:read',
        'help_penilaianpengemudi:read',
        'help_lisensi:read',
        'help_laporan:read',
        'help_pelacakansementara:read',
        'help_bantuandankontakkami:read',
        'help_kendaraan:read',
        'help_karyawan:read',
        'help_pengguna:read',
        'help_grupkendaraan:read',
      ])
    },
    module_alias: [
      'f1-help-login',
      'f2-help-dasbor',
      'f3-help-liveview',
      'f4-help-notifikasi',
      'f5-help-pengaturan',
      'f6-help-masterdata',
      'f7-help-pelacakanvideo',
      'f8-help-penilaianpengemudi',
      'f9-help-lisensi',
      'f10-help-laporan',
      'f11-help-pelacakansementara',
      'f12-help-bantuandankontakkami',
      'f13-help-kendaraan',
      'f14-help-karyawan',
      'f15-help-pengguna',
      'f16-help-grupkendaraan',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: 6,
    label: 'menuitems.contactUs.text',
    link: '/contactus/',
    icon: 'icon-outline_phone',
    isHasAccess: () => {
      return hasAccess('contact:read')
    },
    module_alias: 'g1-kontak',
  },
]

export const firstSection = [
  {
    id: '1',
    label: 'menuitems.dashboards.text',
    link: '/dashboard/',
    isExactPath: true,
    icon: 'icon-outline_grid',
    isHasAccess: () => {
      return hasAccess([
        'a1a-dasbor-statuskendaraan:read',
        'a1e-dasbor-skorpengemudi:read',
        'a1d-dasbor-bahanbakar:read',
        'a1c-dasbor-durasi&totalmengemudi:read',
        'a1b-dasbor-jarak&totalmengemudi:read',
        'a1f-dasbor-kendaraangeolokasi:read',
      ])
    },
    module_alias: ['a1-dasbor', 'a6-dasbor-fuel'],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },

  {
    id: 28,
    label: 'menuitems.liveView.text',
    icon: 'icon-outline_live-view',
    link: '/liveview-2/',
    module_alias: 'b1f-liveview',
    badge: {
      text: 'global.new',
    },
    isHasAccess: () => {
      return hasAccess('b1f-liveview-v2:read')
    },
    redirectTo: redirectLiveview2,
  },

  {
    id: '2',
    label: 'menuitems.liveView.text',
    icon: 'icon-outline_live-view',
    link: '/liveview/',
    isHasAccess: () => {
      return hasAccess('b1a-default-liveview:read')
    },
    module_alias: 'b1-liveview',
    // isNewFeature: (module_alias) => {
    //   return isNewModule(module_alias)
    // },
  },
  {
    id: 38,
    label: 'menuitems.controlTower.text',
    icon: 'icon-outline_activity',
    link: '/controltower-2/',
    module_alias: 'control_tower',
    isHasAccess: () => {
      return hasAccess('h1b-control-tower-v2:read')
    },
    isNewFeature: () => {
      return true
    },
  },
  {
    id: '3',
    label: 'menuitems.controlTower.text',
    icon: 'icon-outline_activity',
    link: '/controltower/',
    module_alias: 'control_tower',
    isHasAccess: () => {
      return hasAccess('control_tower:read')
    },
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: '4',
    hasNotifBadge: true,
    label: 'menuitems.notifikasi.text',
    link: '/notification/',
    icon: 'icon-outline_bell',
    isHasAccess: () => {
      return hasAccess([
        'e1b-web-umum:read',
        'e1c-web-dms:read',
        'e1a-web-perilakupengemudi:read',
        'e1j-log-notification:read',
      ])
    },
    module_alias: ['e1-notifweb', 'e2-popup-notifikasi', 'e3-email-notifikasi'],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: '5',
    label: 'menuitems.laporan.text',
    icon: 'icon-outline_book',
    link: '/report/',
    isHasAccess: () => {
      return hasAccess([
        'a2a-report-geolokasi:read',
        'a2b-report-ringkasangeolokasi:read',
        'report_management_driver:read',
        'a2d-report-ringkasanharianpengemudi:read',
        'report_summary_day_vehicle:read',
        'report_stopped:read',
        'report_detail_vehicle_trip:read',
        'report_vehicle_trip:read',
        'report_management_vehicle:read',
        'report_alert:read',
        'report_driver_behaviour:read',
        'a3e-report-ringkasanpelanggaranpengemudi:read',
        'report_fuel:read',
        'report_door:read',
        'report_time_window:read',
        'raw_sensor_infos:read',
        'a4e-detailjamkerja:read',
        'a4f-detailjamkerjadanpto:read',
        'a4g-detailpto:read',
        'a3f-report-ringkasanperingatan:read',
      ])
    },
    module_alias: [
      'a2-report-pelacakan1',
      'a3-report-pelacakan2',
      'a4-report-sensor',
      'a5-penjadwalan-report',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
]

export const secondSection = [
  {
    id: '6',
    label: 'menuitems.orderManagement.text',
    icon: 'icon-outline_car',
    hasBorderTop: true,
    active: false,
    subItems: [
      {
        id: '39',
        label: 'menuitems.salesOrder.text',
        icon: 'icon-outline_pending_actions',
        link: '/sales-order/',
        isHasAccess: () => {
          return hasAccessAll([
            'sales-order:create',
            'sales-order:delete',
            'sales-order:read',
            'sales-order:update',
          ])
        },
      },
      {
        id: '7',
        label: 'menuitems.deliveryRequest.text',
        icon: 'icon-outline_list',
        link: '/delivery-request/',
        isHasAccess: () => {
          const basicAccess = ['tms:create', 'tms:read', 'tms:update', 'tms:delete']
          const tmsUGroupAccess = [
            ...basicAccess,
            'tms-user-group:create',
            'tms-user-group:delete',
            'tms-user-group:read',
            'tms-user-group:update',
          ]

          const hasBasicAccess = hasAccessAll(basicAccess)
          const hastmsUGroupAccess = hasAccessAll(tmsUGroupAccess)
          const isSuperUser = Helper.methods.isSuperUser()

          const acc = hastmsUGroupAccess ? isSuperUser : hasBasicAccess

          return acc
        },
      },
      {
        id: '8',
        label: 'menuitems.delivery.text',
        icon: 'icon-outline_cube',
        link: '/delivery/',
        isHasAccess: () => {
          return hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        },
        module_alias: 'tms-base-module',
      },
      {
        id: '9',
        label: hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
          ? 'menuitems.fleetTask.text'
          : 'menuitems.fleetTaskInstant.text',
        icon: 'icon-outline_fleet-order',
        link: '/fleet-task/',
        isHasAccess: () => {
          return (
            hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']) ||
            hasAccessAll([
              'fleet-task-instant:read',
              'fleet-task-instant:create',
              'fleet-task-instant:update',
              'fleet-task-instant:delete',
            ])
          )
        },
      },
      {
        id: '22',
        label: 'menuitems.fleetAvailability.text',
        icon: 'icon-outline_calendar',
        link: '/fleet-availability/',
        isHasAccess: () => {
          return (
            hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete']) ||
            hasAccessAll([
              'fleet-task-instant:read',
              'fleet-task-instant:create',
              'fleet-task-instant:update',
              'fleet-task-instant:delete',
            ])
          )
        },
      },
      {
        id: '29',
        label: 'menuitems.invoiceList.text',
        icon: 'icon-outline_file-text',
        link: '/invoice/',
        isHasAccess: () => {
          // TODO: change later when scoped is determined
          return (
            hasAccessAll([
              'tms-integration-accurate:create',
              'tms-integration-accurate:read',
              'tms-integration-accurate:update',
              'tms-integration-accurate:delete',
            ]) && getFeatureFlagData('invoiceCoreFlag').value
          )
        },
      },
      {
        id: '32',
        label: 'menuitems.routeOptimization.text',
        icon: 'icon-fill_pin-time',
        link: '/route-optimization/',
        isHasAccess: () => {
          return hasAccessAll([
            'tms:create',
            'tms:read',
            'tms:update',
            'tms:delete',
            'route-optimization:create',
            'route-optimization:read',
            'route-optimization:update',
            'route-optimization:delete',
          ])
        },
      },
      {
        id: '30',
        label: 'menuitems.deliveryScheduler.text',
        icon: 'icon-outline_scheduler',
        link: '/delivery-scheduler/',
        isHasAccess: () => {
          return hasAccessAll(['tms:create', 'tms:read', 'tms:update', 'tms:delete'])
        },
      },
    ],
  },
  {
    id: '10',
    label: 'menuitems.costManagement.text',
    icon: 'icon-outline_rupiah',
    link: '/cost-management/',
    isHasAccess: () => {
      return hasAccessAll([
        'financial-record:create',
        'financial-record:read',
        'financial-record:update',
        'financial-record:delete',
      ])
    },
  },
  {
    id: '11',
    label: 'menuitems.fleetTracking.text',
    icon: 'icon-outline_calculate',
    active: false,
    subItems: [
      {
        id: '31',
        label: 'menuitems.trackVideo.title',
        icon: 'icon-outline_video',
        link: '/trackvideo-2/',
        isHasAccess: () => {
          if (hasAccessAll(['b3h-new-trackvision-menu:read'])) {
            return false
          }
          return hasAccessAll(['b3d-pelacakan-video-new:read', 'vehicle_video_trackers:read'])
        },
        module_alias: 'b3-pelacakanvideo2',
        isNewFeature: () => {
          return true
        },
      },
      {
        id: '12',
        label: 'menuitems.trackVideo.title',
        icon: 'icon-outline_video',
        link: '/trackvideo/',
        isHasAccess: () => {
          return hasAccessAll(['b3a-default-pelacakanvideo:read', 'vehicle_video_trackers:read'])
        },
        module_alias: 'b3-pelacakanvideo',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
      {
        id: '13',
        label: 'menuitems.trackingTemp.text',
        icon: 'icon-outline_temporary-tracking',
        link: '/trackingtemp/',
        isHasAccess: () => {
          return hasAccess(['temporary_live_views:read'])
        },
        module_alias: 'b2-pelacakansementara',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
      {
        id: '23',
        label: 'menuitems.route.title',
        icon: 'icon-outline_pin-history',
        link: '/route/',
        isHasAccess: () => {
          return hasAccess([
            'd7a-default-md-route:read',
            'd7a-default-md-route:update',
            'd7a-default-md-route:create',
          ])
        },
        module_alias: 'd7-md-route',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
    ],
  },

  {
    id: '34',
    label: 'menuitems.trackVision.text',
    icon: 'icon-outline_video',
    active: false,
    subItems: [
      {
        id: '35',
        label: 'menuitems.liveStreaming.text',
        icon: 'icon-outline_videorecord',
        link: '/live-streaming/',
        isHasAccess: () => {
          return hasAccessAll(['b3h-new-trackvision-menu:read'])
        },
        // TODO : Add module alias
        // module_alias: 'm1-mtc-pemeliharaan',
      },
      {
        id: '36',
        label: 'menuitems.videoHistory.text',
        icon: 'icon-outline_video-history',
        link: '/video-history/',
        isHasAccess: () => {
          return hasAccessAll(['b3h-new-trackvision-menu:read'])
        },
      },
      {
        id: '41',
        label: 'menuitems.videoHistoryNew.text',
        icon: 'icon-outline_video-history',
        link: '/video-history-2/',
        isHasAccess: () => {
          return hasAccessAll(['b3u-trackvision-video-history-v2:read'])
        },
        isNewFeature: () => true,
      },
      {
        id: '37',
        label: 'menuitems.media.text',
        icon: 'icon-outline_image',
        link: '/vehicle-media/',
        isHasAccess: () => {
          return hasAccessAll(['b3i-menu-media:read'])
        },
        // TODO : Add module alias
        // module_alias: 'm1-mtc-pemeliharaan',
      },
    ],
  },

  {
    id: '14',
    label: 'menuitems.fleetManagenent.text',
    icon: 'icon-outline_car-group',
    active: false,
    subItems: [
      {
        id: '15',
        label: 'menuitems.service.text',
        icon: 'icon-outline_truck-maintenance',
        link: '/maintenance/',
        isHasAccess: () => {
          return hasAccess(['maintenance:read', 'maintenance-group:read', 'service_order:read'])
        },
        module_alias: 'm1-mtc-pemeliharaan',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
      {
        id: '16',
        label: 'menuitems.lisensi.text',
        icon: 'icon-outline_license-general',
        link: '/license/',
        isHasAccess: () => {
          return hasAccess(['user_docs:read', 'vehicle_docs:read'])
        },
        module_alias: 'b5-lisensi',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
      {
        id: '1616',
        label: 'menuitems.vehicleInspection.text',
        icon: 'icon-outline_license-general',
        link: '/vehicle-inspection/',
        isHasAccess: () => {
          return (
            hasAccess(['m1e-vehicle-inspection:read']) &&
            isFeatureFlagEnabled('vehicleInspection')
          )
        },
        module_alias: 'm1e-vehicle-inspection',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
      {
        id: '40',
        label: 'menuitems.cdmSecurityMonitoring.text',
        icon: 'icon-outline_shield',
        link: '/cdm-security-monitoring/',
        isHasAccess: () => {
          return hasAccessAll([
            'cdm-monitoring:read', // for alert codes: 122, 127, 128, 129
            'cdm-monitoring:update',
            'z1b-itemp:read', // for alert codes: 18
            'z1f-idoor:read', // for alert codes: 19
            'e1o-general-camera-offline:read', // for alert codes: 126
          ])
        },
      },
      {
        id: '27',
        label: 'menuitems.landMeasurement.text',
        icon: 'icon-outline_radio-button-on',
        link: '/land-measurement/',
        isHasAccess: () => {
          return hasAccessAll([
            'i1a-landmeasurement:read',
            'i1a-landmeasurement:create',
            'i1a-landmeasurement:update',
            'i1a-landmeasurement:delete',
          ])
        },
        module_alias: 'i-landmeasurement',
        isNewFeature: (module_alias) => {
          return isNewModule(module_alias)
        },
      },
    ],
  },
  {
    id: '17',
    label: 'menuitems.penilaianPengemudi.text',
    icon: 'icon-outline_driver',
    link: '/driverscore/',
    isHasAccess: () => {
      return hasAccessAll(['b4a-penilaian-pengemudi-v2:read'])
    },
    module_alias: 'b4-penilaianpengemudi',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
]

export const thirdSection = [
  {
    id: '18',
    label: 'menuitems.masterData.text',
    icon: 'icon-outline_layers',
    link: '/master/',
    hasBorderTop: true,
    isHasAccess: () => {
      return hasAccess([
        'd1a-default-mdkendaraan:read',
        'd2a-default-mdpelacak:read',
        'd3a-default-mdalamat:read',
        'd4a-default-mdpengguna:read',
        'd5a-default-mdkaryawan:read',
        'd7a-default-md-route:read',
        'tms:read',
        'z1o-ibeacon-md:read',
      ])
    },
    module_alias: [
      'd1-md-kendaraan',
      'd2-md-pelacak',
      'd3-md-alamat',
      'd4-md-pengguna',
      'd5-md-karyawan',
      'd6-md-pelanggan',
      'd7-md-route',
      'tms-base-module',
      'z1-sensor',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: '19',
    label: 'menuitems.setting.text',
    link: '/setting/',
    icon: 'icon-outline_settings',
    module_alias: [
      'c1-set-pengguna',
      'c2-set-karyawan',
      'c3-set-kendaraan',
      'c4-set-umum',
      'c5-set-grupkendaraan',
      'c6-set-odometer',
      'c7-set-pengembang',
      'c8-set-profilperusahaan',
      'c9-set-device-timeout',
      'c10-set-pemeliharaan',
    ],
    isHasAccess: () => {
      return hasAccess([
        'c1a-default-setpengguna:read',
        'c2a-default-setkaryawan:read',
        'c3a-default-setkendaraan:read',
        'c4a-default-setumum:read',
        'c5a-default-setgrupkendaraan:read',
        'vehicle_odometer:read',
        'c7a-default-setpengembang:read',
        'c8a-default-set-profil-perusahaan:read',
      ])
    },
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: '33',
    label: 'menuitems.marketplace.text',
    link: '/marketplace/',
    icon: 'icon-outline_marketplace',
    isHasAccess: () => {
      return hasAccessAll(['marketplace:read'])
    },
    module_alias: ['y3-marketplace'],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
  {
    id: '20',
    label: 'menuitems.help.text',
    link: '/help/',
    icon: 'icon-outline_question-mark-circle',
    isHasAccess: () => {
      return hasAccess([
        'help_login:read',
        'help_dasbor:read',
        'help_default:read',
        'help_notifikasi:read',
        'help_pengaturan:read',
        'help_masterdata:read',
        'help_pelacakanvideo:read',
        'help_penilaianpengemudi:read',
        'help_lisensi:read',
        'help_laporan:read',
        'help_pelacakansementara:read',
        'help_bantuandankontakkami:read',
        'help_kendaraan:read',
        'help_karyawan:read',
        'help_pengguna:read',
        'help_grupkendaraan:read',
      ])
    },
    module_alias: [
      'f1-help-login',
      'f2-help-dasbor',
      'f3-help-liveview',
      'f4-help-notifikasi',
      'f5-help-pengaturan',
      'f6-help-masterdata',
      'f7-help-pelacakanvideo',
      'f8-help-penilaianpengemudi',
      'f9-help-lisensi',
      'f10-help-laporan',
      'f11-help-pelacakansementara',
      'f12-help-bantuandankontakkami',
      'f13-help-kendaraan',
      'f14-help-karyawan',
      'f15-help-pengguna',
      'f16-help-grupkendaraan',
    ],
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
    redirectTo: () => {
      setTimeout(() => {
        window.open('https://kb.mceasy.com/docs', '_blank')
      }, 300)
    },
  },
  {
    id: '21',
    label: 'menuitems.contactUs.text',
    link: '/contactus/',
    icon: 'icon-outline_phone',
    isHasAccess: () => {
      return hasAccess('contact:read')
    },
    module_alias: 'g1-kontak',
  },
  {
    id: '22',
    label: 'menuitems.companyTicket.text',
    link: '/company-ticket/',
    icon: 'icon-outline_complaint',
    isHasAccess: () => {
      return hasAccess('company_ticket:read')
    },
    module_alias: '0f-base-company-ticket',
    isNewFeature: (module_alias) => {
      return isNewModule(module_alias)
    },
  },
]
